import { Attributes, NeoModel, Rules, Validation, ValueObject } from "@singularsystems/neo-core";

@NeoModel
export default class MissingExchangeRatesReportCriteria extends ValueObject  
{
    @Rules.Required()
    @Attributes.Date()
    public startDate: Date | null = new Date();

    @Rules.Required()
    @Attributes.Date()
    public endDate: Date | null = new Date();

    protected addBusinessRules(rules: Validation.Rules<this>) {
        super.addBusinessRules(rules);
        rules.failWhen(() => this.endDate !== null && this.startDate !== null && this.endDate < this.startDate, "End Date must be greater than or equal to Start Date.");
    }
}